import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { X, Check } from 'lucide-react';
export function CerebroDigital() {
  const comparisons = [{
    task: 'Te preguntan un caso práctico',
    without: 'Buscás la norma de memoria',
    with: 'Aplicás el Escáner de Hechos en 30 segundos'
  }, {
    task: 'El profesor te repregunta',
    without: 'Te bloqueás o cedés',
    with: 'Usás los 5 tipos de respuesta estratégica'
  }, {
    task: 'Tenés que argumentar',
    without: 'Citás el artículo y listo',
    with: 'Usás la Doble Fundamentación de 6 capas'
  }, {
    task: 'Conectar materias',
    without: 'Civil, Constitucional y Historia por separado',
    with: 'Ves el sistema completo y los 5 puentes'
  }, {
    task: 'Preparar el 2do año',
    without: 'Sin estrategia',
    with: 'Con el Plan Maestro de continuidad normativa'
  }, {
    task: 'Buscar jurisprudencia',
    without: 'Google y rezar',
    with: 'Protocolo de búsqueda avanzada en 4 pasos'
  }];
  return <section className="py-6 px-4 max-w-3xl mx-auto" data-id="element-52">
      <FadeIn data-id="element-53">
        <h2 className="text-xl md:text-2xl font-bold text-center mb-5 flex items-center justify-center gap-2" data-id="element-54">
          <span className="text-2xl" data-id="element-55">🧠</span> ¿QUÉ AGREGA EL MÉTODO 360°?
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden" data-id="element-56">
          <div className="grid grid-cols-3 bg-gray-800/80 border-b border-gray-700 p-2.5 font-bold text-xs md:text-sm" data-id="element-57">
            <div className="text-gray-400" data-id="element-58">Situación</div>
            <div className="text-red-400 text-center" data-id="element-59">Sin Método 360°</div>
            <div className="text-amber-400 text-center" data-id="element-60">Con Método 360°</div>
          </div>

          <div className="divide-y divide-gray-800/50" data-id="element-61">
            {comparisons.map((item, index) => <div key={index} className="grid grid-cols-3 p-2.5 items-center text-xs md:text-sm hover:bg-gray-800/30 transition-colors" data-id="element-62">
                <div className="font-medium text-gray-300 pr-2" data-id="element-63">
                  {item.task}
                </div>
                <div className="text-center text-gray-400 flex flex-col items-center gap-0.5" data-id="element-64">
                  <X size={14} className="text-red-500/50" data-id="element-65" />
                  <span data-id="element-66">{item.without}</span>
                </div>
                <div className="text-center font-bold text-amber-400 flex flex-col items-center gap-0.5 bg-amber-900/10 py-1.5 rounded-lg" data-id="element-67">
                  <Check size={14} className="text-amber-500" data-id="element-68" />
                  <span data-id="element-69">{item.with}</span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-5 text-center" data-id="element-70">
          <p className="text-base font-bold text-gray-200 mb-1" data-id="element-71">
            6 Módulos · Rueda de Conexión Normativa · Dictamen Básico · Plan de
            Excelencia Personal
          </p>
        </div>
      </FadeIn>
    </section>;
}